import { db } from '@/api/firebase'
import { DBSubscription, Subscription } from '../../models'

const subscriptionConverter: firebase.firestore.FirestoreDataConverter<Subscription> = {
  toFirestore(subscription: Subscription): DBSubscription {
    const { expiring, plan, ...dbSubscription} = subscription
    return dbSubscription as DBSubscription
  },
  fromFirestore(snap, options): Subscription {
    const dbSubscription = snap.data(options) as DBSubscription
    return Subscription(dbSubscription)
  }
}

const subscriptionsRef = db.collection('subscriptions').withConverter(subscriptionConverter)
const subscriptionRef = (userId: string) => subscriptionsRef.doc(userId)

export {
  subscriptionRef
}